module.exports = __webpack_public_path__ + "img/download.dfcd6d8f.svg";